export default "__VITE_ASSET__CqkV0fNB__"